import {Root} from '@radix-ui/react-collapsible';
import {useState} from 'react';

type Props = Omit<React.ComponentProps<typeof Root>, 'children'> & {
  children: (isOpen: boolean) => React.ReactNode;
};
export function Collapsible({
  open,
  onOpenChange,
  defaultOpen,
  children,
  ...props
}: Props): React.JSX.Element {
  const [isOpen, setIsOpen] = useState(defaultOpen || false);

  return (
    <Root {...props} open={isOpen} onOpenChange={setIsOpen}>
      {children(isOpen)}
    </Root>
  );
}

Collapsible.displayName = 'Collapsible';
